import { Spinner } from '@fluentui/react-components';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const IngestPayloadDetailPage = lazy(() =>
  import('../../pages/admin/ingest/IngestPayloadDetailPage').then((m) => ({
    default: m.IngestPayloadDetailPage,
  })),
);

export const Route = createFileRoute('/admin/ingest_/$origin/payloads/$id')({
  component: () => (
    <Suspense
      fallback={<Spinner style={{ position: 'absolute', top: '25%', left: '50%', transform: 'translateX(-50%)' }} />}
    >
      <IngestPayloadDetailPage />
    </Suspense>
  ),
});
